import React from 'react';
import UserAvatar from '../ui/UserAvatar';
import { agentIconFor } from '../agents/agentIcons';
import { commentAgentOf, COMMENT_AGENTS } from '../../extensions/bundled/task-manager/commentMentions';
import './CommentAuthor.css';

/**
 * Who wrote a task comment: a person (their avatar) or an AI agent over MCP —
 * then the agent's own brand icon, the same one its Terminal pane shows, and
 * an "AI agent" badge (card 13eb6ec0). An agent with no icon, a person, and a
 * legacy comment all keep the initials avatar.
 */
export function CommentAvatar({ comment, name, className }) {
  const agent = commentAgentOf(comment);
  const Brand = agentIconFor(agent);
  if (Brand) {
    return (
      <span
        className={`${className} comment-agent-avatar`}
        data-agent-icon={agent}
        role="img"
        aria-label={COMMENT_AGENTS[agent]}
        // 28px like UserAvatar beside it (its size is inline, too).
        style={{ width: 28, height: 28 }}
      >
        <Brand width={16} height={16} focusable="false" />
      </span>
    );
  }
  return <UserAvatar className={className} userId={comment.authorId} name={name} size={28} />;
}

/** "AI agent" next to the name of a comment an agent wrote. */
export function CommentAgentBadge({ comment }) {
  if (!commentAgentOf(comment)) return null;
  return <span className="comment-agent-badge">AI agent</span>;
}
